// Token storage/session helpers. Centralized here so the storage mechanism
// (localStorage today) can change without touching call sites.

const ACCESS_KEY = "arkii_access_token";
const REFRESH_KEY = "arkii_refresh_token";
const USER_KEY = "arkii_user";
const LANG_KEY = "arkii_lang";
const PENDING_VERIFICATION_EMAIL_KEY = "arkii_pending_verification_email";
const PENDING_VERIFICATION_EXPIRES_KEY = "arkii_pending_verification_expires_at";

export function getAccessToken() {
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY);
}

export function setTokens(access, refresh) {
  localStorage.setItem(ACCESS_KEY, access);
  if (refresh) {
    localStorage.setItem(REFRESH_KEY, refresh);
  }
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
}

export function getStoredUser() {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function setStoredUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

// The app-shell's chosen display language, cached client-side for instant
// paint on load — before the user's own profile (the real source of truth
// once loaded) comes back from GET /user/me/.
export function getStoredLang() {
  return localStorage.getItem(LANG_KEY);
}

export function setStoredLang(lang) {
  localStorage.setItem(LANG_KEY, lang);
}

// sessionStorage, not localStorage: this is scoped to the current
// signup/verify attempt and shouldn't linger once the tab closes.
export function getPendingVerificationEmail() {
  return sessionStorage.getItem(PENDING_VERIFICATION_EMAIL_KEY);
}

export function setPendingVerificationEmail(email) {
  if (email) {
    sessionStorage.setItem(PENDING_VERIFICATION_EMAIL_KEY, email);
  }
}

export function clearPendingVerificationEmail() {
  sessionStorage.removeItem(PENDING_VERIFICATION_EMAIL_KEY);
  sessionStorage.removeItem(PENDING_VERIFICATION_EXPIRES_KEY);
}

// Epoch ms the outstanding code dies at. Persisted alongside the pending
// email so a page refresh keeps counting down instead of resetting to a
// fresh 10 minutes.
export function getVerificationExpiresAt() {
  const raw = sessionStorage.getItem(PENDING_VERIFICATION_EXPIRES_KEY);
  return raw ? Number(raw) : null;
}

export function setVerificationExpiresAt(timestamp) {
  sessionStorage.setItem(PENDING_VERIFICATION_EXPIRES_KEY, String(timestamp));
}
